import React from "react"
import * as styles from "./vertical-spacing.module.scss"

export default function VerticalSpacingRow(props) {
  return  <div className={styles.separator}></div>
}
